import React, { useContext, useState } from 'react';
import { Button } from '@mui/material';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { CartContext } from '../../../contexts/CartContext';
import OptionPopup from './OptionPopup';

const styles = {
  btnStyle: {
    backgroundColor: '#E50218',
    color: 'white',
    borderRadius: '7.11px',
    minWidth: '15px',
    width: '25px',
    height: '25px',
  },
  icon: {
    fontSize: '20px',
  },
};

function ProductAddView({ product }) {
  const { addItemToCart } = useContext(CartContext);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [popupOpen, setPopupOpen] = useState(false);

  const addToCartBtnPressed = () => {
    const hasOptions = product.options?.product_options?.length > 0;

    if (hasOptions) {
      setSelectedProduct(product);
      setPopupOpen(true);
    } else {
      
      addItemToCart({
        ...product,
        selectedOption: null,
        price: product.price,
        quantity_ratio: 1,
        cartKey: `${product.id}`
      });
    }
  };

  const handleOptionSelect = (option) => {
    if (!selectedProduct) return;

    const key = `${selectedProduct.id}_${option.label.replace(/\s+/g, '_')}`;

    const itemToAdd = {
      ...selectedProduct,
      cartKey: key,
      selectedOption: option,
      name: `${selectedProduct.name} ${option.label}`,
      price: option.price,
      quantity_ratio: option.quantity_ratio,
    };

    addItemToCart(itemToAdd);
    setPopupOpen(false);
    setSelectedProduct(null);
  };

  return (
    <>
      <Button
        style={styles.btnStyle}
        onClick={(e) => {
          e.stopPropagation();
          addToCartBtnPressed();
        }}
      >
        <AddRoundedIcon style={styles.icon} />
      </Button>
      {selectedProduct && (
        <OptionPopup
          open={popupOpen}
          onClose={() => setPopupOpen(false)}
          product={selectedProduct}
          onSelectOption={handleOptionSelect}
        />
      )}
    </>
  );
}

export default ProductAddView;
